import {defineAsyncComponent, defineComponent} from "vue";
import QwEmpty from "@/core/components/Controls/QwEmpty.vue";
import LoadingIndicator from "@/core/components/LoadingIndicator.vue";

export const PublicToolDemoImplementationEnum = Object.freeze({
	STANDALONE_WHEEL_OF_LIFE: "standaloneWheelOfLife",
})

const StandalonePublicDemoLoadingPlaceholder = defineComponent({
	name: "StandalonePublicDemoLoadingPlaceholder",
	components: {
		QwEmpty,
		LoadingIndicator,
	},
	template: `
		<div class="card p-3 mt-3 public-tool-demo-shell-root__placeholder">
			<QwEmpty hide-action-button hide-image>
				<template #title>Loading demo...</template>
			</QwEmpty>
			<div class="public-tool-demo-shell-root__placeholder-loader">
				<LoadingIndicator
					:is-loading="true"
					message="Loading..."
				/>
			</div>
		</div>
	`,
})

const standalonePublicDemoComponentRegistry = {
	[PublicToolDemoImplementationEnum.STANDALONE_WHEEL_OF_LIFE]: defineAsyncComponent({
		loader: async () => {
			await import("@/entry/importFull.js")
			return await import("@/core/modules/coach/Resources/CoachingTools/GenericTools/PublicDemo/standalone/WheelOfLifePublicDemoAdapter.vue")
		},
		loadingComponent: StandalonePublicDemoLoadingPlaceholder,
		delay: 0,
	}),
}

export function getStandalonePublicDemoComponent(demoImplementation) {
	return standalonePublicDemoComponentRegistry[demoImplementation] || null
}
